import { useEffect } from "react";

type SeoOptions = {
  title: string;
  description?: string;
  keywords?: string;
};

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * 页面级 TDK 设置（SPA 演示站点）。
 */
export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (keywords) {
      setMeta("name", "keywords", keywords);
    }
    setMeta("property", "og:title", title);
  }, [title, description, keywords]);
}

export default useSeo;